module.exports = __webpack_public_path__ + "img/cdex.cb05d95e.png";